import { Icon } from '@chakra-ui/react'

export const InfoIcon = () => (
    <Icon viewBox="0 0 16 16" w="16px" h="16px" fill="none">
        <circle cx="8" cy="8" r="7" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.733398 8C0.733398 3.98673 3.9868 0.733337 8.00006 0.733337C12.0133 0.733337 15.2667 3.98673 15.2667 8C15.2667 12.0133 12.0133 15.2667 8.00006 15.2667C3.9868 15.2667 0.733398 12.0133 0.733398 8ZM8.00008 6.73333C8.33145 6.73333 8.60008 7.00196 8.60008 7.33333V11.3333C8.60008 11.6647 8.33145 11.9333 8.00008 11.9333C7.66871 11.9333 7.40008 11.6647 7.40008 11.3333V7.33333C7.40008 7.00196 7.66871 6.73333 8.00008 6.73333ZM8.00008 6C8.36827 6 8.66675 5.70152 8.66675 5.33333C8.66675 4.96514 8.36827 4.66667 8.00008 4.66667C7.63189 4.66667 7.33342 4.96514 7.33342 5.33333C7.33342 5.70152 7.63189 6 8.00008 6Z"
            fill="#77777C"
        />
    </Icon>
)